import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { Navigate } from "react-router-dom";

export const reviewsRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "Reviews", breadcrumbNavigate: false },
    children: [
      { index: true, element: <Navigate replace to="dashboard" /> },
      {
        path: "dashboard",
        handle: { breadcrumb: "Dashboard" },
        async lazy() {
          const { Dashboard } = await import("./dashboard/dashboard");
          return { Component: Dashboard };
        },
      },
      {
        path: "all-reviews",
        handle: { breadcrumb: "All reviews" },
        async lazy() {
          const { AllReviews } = await import(
            "./all-reviews/all-reviews-table"
          );
          return { Component: AllReviews };
        },
      },
      {
        path: "products",
        handle: { breadcrumb: "Products" },
        async lazy() {
          const { Products } = await import("./products/review-products-table");
          return { Component: Products };
        },
      },
      {
        handle: { breadcrumb: "Response" },
        path: "reviews-response",
        async lazy() {
          const { Response } = await import(
            "./form-and-response/response/response"
          );
          return { Component: Response };
        },
      },
      {
        handle: { breadcrumb: "Settings" },
        path: "settings",
        async lazy() {
          const { Settings } = await import("./settings/settings");
          return { Component: Settings };
        },
      },
      {
        handle: { breadcrumb: "Displays & Widgets" },
        path: "reviews-displays-widgets",
        children: [
          {
            index: true,
            async lazy() {
              const { DisplaysWidgets } = await import(
                "./form-and-response/displays-widgets"
              );
              return { Component: DisplaysWidgets };
            },
          },
          {
            path: "review-form",
            handle: { breadcrumb: "Edit" },
            async lazy() {
              const { FormBuilder } = await import(
                "./form-and-response/form-builder/form-builder"
              );
              return { Component: FormBuilder };
            },
          },
          {
            path: "star-rating-widget",
            handle: { breadcrumb: "Star rating widget" },
            async lazy() {
              const { StarRatingWidgetBuilder } = await import(
                "./form-and-response/star-rating-widget/star-rating-widget-builder"
              );
              return { Component: StarRatingWidgetBuilder };
            },
          },
        ],
      },
    ],
  },
];
